export type LegalLocale = 'en' | 'pt';

/**
 * Maps an i18next language tag onto the two legal-document locales.
 * Portuguese tags keep the original Brazilian instruments; everything
 * else, including en-US, uses the English translation.
 */
export function resolveLegalLocale(language: string): LegalLocale {
  return language.toLowerCase().startsWith('pt') ? 'pt' : 'en';
}
